import axios from 'axios'

export default {
    getAll: () => axios.get(`/booking`),
    getById: id => axios.get(`/booking/${id}`),
    edit: formData => axios.put(`/booking/edit`, formData),
    update: formData => axios.patch(`/booking/update`, formData),
    searchById: formData => axios.post(`/booking/search`, formData)
}
